/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

export const DOCS_URL = 'https://docs.poweralpha.com';

export function getSupportTicketUrl(context = ''): string {
  const timestamp = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'shortGeneric',
  }).format(new Date());
  const body = encodeURIComponent(
    `${context}\n\nPath: ${window.location.pathname}${window.location.search}\nTimestamp: ${timestamp}\r\n\r\n------------------------------------------------------------\r\n` +
      'Do not make changes below this line\r\n## [PA TICKET] ##',
  );
  return `mailto:support.poweralpha@brightnightpower.com?body=${body}`;
}
